import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgPrivate = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={8} cy={8} r={7.5} stroke="currentColor" />
    <circle cx={8} cy={7} r={1.5} stroke="currentColor" />
    <path
      d="M8 8.5v3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPrivate);
export default ForwardRef;
